import { useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CTAs from "../../components/CTAs";
import Footer from "../../components/Footer";
import { Sms } from "iconsax-reactjs";

const ResendMailPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  const handleOpenEmailApp = () => {
    if (!email) return;
    const domain = email.split("@")[1];

    if (domain === "gmail.com") {
      window.open(
        `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`,
        "_blank",
      );
    } else if (
      domain === "outlook.com" ||
      domain === "hotmail.com" ||
      domain === "live.com"
    ) {
      window.open(
        `https://outlook.office.com/mail/deeplink/compose?to=${email}`,
        "_blank",
      );
    } else if (domain === "yahoo.com") {
      window.open(`https://compose.mail.yahoo.com/?to=${email}`, "_blank");
    } else {
      // Fallback: opens default email client
      window.location.href = `mailto:${email}`;
    }
  };

  const handleBackToLogin = useCallback(() => {
    navigate("/login");
  }, [navigate]);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700&display=swap');

        html, body {
          margin: 0;
          background: #ffffff !important;
        }

        .dd-root {
          font-family: 'DM Sans', sans-serif;
          background: #ffffff;
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 0 20px;
        }

        .dd-form-container {
          width: 400px;
          max-width: 100%;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          gap: 24px;
          margin: auto;
        }

        .dd-section-label {
          font-size: 14px; font-weight: 700; color: #0F172A;
          margin-bottom: 6px; display: block;
        }

        .dd-required { color: #EF4444; margin-left: 2px; }

        .dd-input-group { display: flex; flex-direction: column; gap: 6px; }

        .dd-input {
          width: 100%; box-sizing: border-box;
          padding: 12px 14px;
          border: 1px solid #E2E8F0; border-radius: 8px;
          font-family: 'DM Sans', sans-serif; font-size: 14px;
          color: #1E293B; background: #FFFFFF; outline: none;
          transition: border-color 0.15s;
        }
        .dd-input:focus {
          border-color: #2563EB;
          box-shadow: 0 0 0 3px rgba(37,99,235,0.1);
        }

        .dd-link {
          font-size: 13px; font-weight: 600; color: #2563EB;
          text-decoration: none; cursor: pointer;
        }
        .dd-link:hover { text-decoration: underline; }
        .dd-text { font-size: 13px; color: #64748B; }

        /* Circle icon */
        .dd-icon-circle {
          width: 48px; height: 48px; border-radius: 8px;
          background: #F8FAFC; border: 1px solid #E2E8F0;
          display: flex; align-items: center; justify-content: center;
          margin-bottom: 8px;
        }
      `}</style>

      <div className="dd-root">
        <div className="dd-form-container">
          {/* Icon and Title */}
          <div style={{ textAlign: "center" }}>
            <div className="dd-icon-circle" style={{ margin: "0 auto 16px" }}>
              <Sms size={20} />
            </div>
            <h1
              style={{
                fontSize: "24px",
                fontWeight: 700,
                color: "#0F172A",
                margin: "0 0 8px 0",
              }}
            >
              Check your email
            </h1>
            <p className="dd-text" style={{ lineHeight: 1.6 }}>
              We sent a password reset link to
              <br />
              <strong style={{ fontWeight: 600, color: "#1E293B" }}>
                {email || "your email"}
              </strong>
            </p>
          </div>

          {/* Open email app button */}
          <CTAs
            type="Signinbtn"
            text="Open email app"
            width="100%"
            onClick={handleOpenEmailApp}
          />

          {/* Back to login */}
          <div
            style={{
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            <img
              src="assets/arrow-left.svg"
              alt=""
              style={{ width: 20, height: 20 }}
            />
            <span
              className="dd-link"
              onClick={handleBackToLogin}
              style={{ display: "flex", alignItems: "center" }}
            >
              Back to login
            </span>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default ResendMailPage;
